// 引入路由配置
import {
    _get,
    formatRouteUrl,
    isUndefined,
    jsonToUrlParam,
    urlParamToJson
} from '@/utils/utils.js';

// 路由列表
export const routerList = ROUTES;

// 路由 map 表，以 path 为 key
export const routerMap = ROUTES_MAP;

// 路由 map 表，以 alias 别名为 key
export const routerAliasMap = ROUTES_ALIAS_MAP;

export const router = {
    navigateTo: () => (() => {}),
    redirectTo: () => (() => {}),
    switchTab: () => (() => {}),
    reLaunch: () => (() => {}),
    onBefore: () => (() => {}),
    onAfter: () => (() => {}),
    onError: () => (() => {}),
}


const tabBarQuery = {};
/**
 * 设置 tabBar 入参
 * @param alias 路由别名
 * @param query 路由入参
 */
const setTabBarQuery = (alias, query) => {
    tabBarQuery[alias] = query;
}

/**
 * 获取 tabBar 入参
 * @param alias 路由别名
 * @returns {*}
 */
export const getTabBarQuery = (alias) => {
    return tabBarQuery[alias];
}

const callback = (targetRoute, options = {}) => {
    return {
        ...(options.events || {}),
        success(res) {
            router.onAfter && router.onAfter({ ...res, _targetRoute: targetRoute, _options: options });
            options.success && options.success({ ...res, _targetRoute: targetRoute, _options: options });
        },
        fail(err) {
            console.error(err);
            router.onError && router.onError({
                _msg: err,
                _code: 400,
                _targetRoute: targetRoute,
                _options: options
            });
        }
    }
}

/**
 * 解析 options ，定位当前路由
 * @param options
 * @returns {*|null}
 */
export const getTargetRoute = (options) => {
    try {
        let targetPath = null;
        if (options.url) {
            targetPath = options.url.split('?')[0];
        }
        // 路由解析权重
        // url > 别名解析 > options.path
        return routerMap[targetPath] || routerAliasMap[options.name] || routerMap[options.path];
    } catch (e) {
        return null;
    }
}

/**
 * 获取最终掉用原生方法的入参 url
 * @param targetRoute
 * @param options
 * @returns {*}
 */
const getRouteUrl = (targetRoute, options) => {
    if (options.url) {
        return options.url;
    }
    return formatRouteUrl(targetRoute.path, jsonToUrlParam(options.query || {}));
}

/**
 * 初始化路由
 * @param options
 * @returns {{targetRoute: *, url: *}|boolean}
 */
const initBaseRoute = (options) => {
    // 目标路由
    const targetRoute = getTargetRoute(options);
    // 当前跳转页面不在路由配置表,跳转404
    if (!targetRoute) {
        console.error('未定义的路由~')
        router.onError && router.onError(options, {
            _msg: '页面404未查询到',
            _code: 404
        });
        return false;
    }
    // 前置拦截
    const beforeResult = router.onBefore && router.onBefore({ _targetRoute: targetRoute, _options: options });
    if (!beforeResult && !isUndefined(beforeResult)) {
        return false
    }
    // 组装参数
    const url = getRouteUrl(targetRoute, options);
    return {
        url,
        targetRoute
    }
}

router.navigateBack = function (options = {}) {
    uni.navigateBack(options);
}

// #ifdef MP-WEIXIN
Object.keys(router).forEach(method => {
    if (method === 'navigateBack') return;
    router[method] = (options) => {
        const route = initBaseRoute(options);
        if (!route) return;
        const run = (m) => {
            uni[m]({
                url: route.url,
                ...callback(route.targetRoute, options)
            })
        }
        // tabBar 跳转，存储路由入参
        if (_get(route, 'targetRoute.meta.tabBar', null)) {
            setTabBarQuery(route.targetRoute.alias, urlParamToJson(route.url))
            // 目标路由是tabBar页面，但跳转方式非已下两种
            if (!['reLaunch', 'switchTab'].includes(method)) {
                return run('switchTab');
            }
        }
        run(method);
    }
})
// #endif

// #ifdef H5
Object.keys(router).forEach(method => {
    if (method === 'navigateBack') return;
    router[method] = (options) => {
        const route = initBaseRoute(options);
        if (!route) return;
        const run = (m) => {
            switch (m) {
                case 'navigateTo':
                    uni.navigateTo({
                        url: route.url,
                        ...callback(route.targetRoute, options)
                    })
                    break;
                case 'redirectTo':
                    uni.redirectTo({
                        url: route.url,
                        ...callback(route.targetRoute, options)
                    })
                    break;
                case 'switchTab':
                    uni.switchTab({
                        url: route.url,
                        ...callback(route.targetRoute, options)
                    })
                    break;
                case 'reLaunch':
                    uni.reLaunch({
                        url: route.url,
                        ...callback(route.targetRoute, options)
                    })
                    break;
            }
        }
        // tabBar 跳转，存储路由入参
        if (_get(route, 'targetRoute.meta.tabBar', null)) {
            setTabBarQuery(route.targetRoute.alias, urlParamToJson(route.url))
            // 目标路由是tabBar页面，但跳转方式非已下两种
            if (!['reLaunch', 'switchTab'].includes(method)) {
                return run('switchTab');
            }
        }
        run(method);
    }
})
// #endif
